export default __webpack_public_path__ + "static/media/check-circle.245f7013.svg";